import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { AbilityService } from 'ability';
import { isNil } from 'lodash';
import { PermissionsEnum } from 'mbs-ui-shared@models';
import { LicensesService } from 'mbs-ui-shared@services/licenses.service';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { LicensesStoreSelectors } from '.';
import * as LicensesActions from './actions';

@Injectable()
export class LicensesEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);
  private licensesFacade = inject(LicensesService);
  private ability = inject(AbilityService);
  loadPermissionsFlagsEffect = createEffect(() => {
    return this.actions$.pipe(
      ofType(LicensesActions.loadPermissionFlags),
      concatLatestFrom(() => this.store.select(LicensesStoreSelectors.selectPermissionFlags)),
      filter(([action, flags]) => isNil(flags) || action.force),
      switchMap(() => {
        return this.licensesFacade.getPermissionFlags().pipe(
          tap((flags) => {
            // TODO: Add to ability all flags
            flags.isBuyLicensesAllow && this.ability.addRule({ actions: 'read', subject: 'isBuyLicensesAllow' });
          }),
          map((flags) => LicensesActions.setPermissionFlags({ permissionFlags: flags }))
        );
      })
    );
  });

  loadBalanceEffect = createEffect(() => {
    return this.actions$.pipe(
      ofType(LicensesActions.loadBalance),
      concatLatestFrom(() => this.store.select(LicensesStoreSelectors.selectBalance)),
      filter(([action, balance]) => isNil(balance)),
      switchMap(() => {
        return this.licensesFacade.getBalance().pipe(map((balance) => LicensesActions.setBalance({ balance: balance })));
      })
    );
  });

  loadSubscriptionEditLinkEffect = createEffect(() => {
    return this.actions$.pipe(
      ofType(LicensesActions.loadSubscriptionEditLink),
      concatLatestFrom(() => this.store.select(LicensesStoreSelectors.selectSubscriptionEditLink)),
      filter(([action, link]) => isNil(link) && this.ability.can('read', PermissionsEnum.ManageSubscription)),
      switchMap(() => {
        return this.licensesFacade.getSubscriptionEditLink().pipe(map((link) => LicensesActions.setSubscriptionEditLink({ link })));
      })
    );
  });
}
